var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKalendarz3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M50,2c-0.553,0-1,0.447-1,1v1v2v4c0,0.553,0.447,1,1,1s1-0.447,1-1V6V4V3C51,2.447,50.553,2,50,2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M14,2c-0.553,0-1,0.447-1,1v1v2v4c0,0.553,0.447,1,1,1s1-0.447,1-1V6V4V3C15,2.447,14.553,2,14,2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M62,60c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V17h60V60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M62,15H2V8c0-1.104,0.896-2,2-2h7v4c0,1.657,1.343,3,3,3s3-1.343,3-3V6h30v4c0,1.657,1.343,3,3,3 s3-1.343,3-3V6h7c1.104,0,2,0.896,2,2V15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M11,54h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C10,53.553,10.447,54,11,54z M12,49h4v3h-4V49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M23,54h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C22,53.553,22.447,54,23,54z M24,49h4v3h-4V49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M35,54h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C34,53.553,34.447,54,35,54z M36,49h4v3h-4V49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M11,43h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C10,42.553,10.447,43,11,43z M12,38h4v3h-4V38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M23,43h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C22,42.553,22.447,43,23,43z M24,38h4v3h-4V38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M35,43h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C34,42.553,34.447,43,35,43z M36,38h4v3h-4V38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M47,43h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C46,42.553,46.447,43,47,43z M48,38h4v3h-4V38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M11,32h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C10,31.553,10.447,32,11,32z M12,27h4v3h-4V27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M23,32h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C22,31.553,22.447,32,23,32z M24,27h4v3h-4V27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M35,32h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C34,31.553,34.447,32,35,32z M36,27h4v3h-4V27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M47,32h6c0.553,0,1-0.447,1-1v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5 C46,31.553,46.447,32,47,32z M48,27h4v3h-4V27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,4h-7V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v1H17V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v1H4 C1.789,4,0,5.789,0,8v52c0,2.211,1.789,4,4,4h56c2.211,0,4-1.789,4-4V8C64,5.789,62.211,4,60,4z M49,3c0-0.553,0.447-1,1-1 s1,0.447,1,1v7c0,0.553-0.447,1-1,1s-1-0.447-1-1V3z M13,3c0-0.553,0.447-1,1-1s1,0.447,1,1v7c0,0.553-0.447,1-1,1s-1-0.447-1-1 V3z M62,60c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V17h60V60z M62,15H2V8c0-1.104,0.896-2,2-2h7v4c0,1.657,1.343,3,3,3 s3-1.343,3-3V6h30v4c0,1.657,1.343,3,3,3s3-1.343,3-3V6h7c1.104,0,2,0.896,2,2V15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 27,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 27,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 49,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 49,
    fill: "#B4CCB9",
    width: 4,
    height: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalendarz3);
export default __webpack_public_path__ + "static/media/kalendarz3.5dc13f9d7ae59a7b9cb8194e3434ed2a.svg";
export { ForwardRef as ReactComponent };